export default "__VITE_ASSET__af20b901__"